import React, { Component } from "react";
import Chart from "react-apexcharts";

class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartData: props.chartData || [],
      chartOptions: props.chartOptions || {},
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.chartData !== this.props.chartData ||
      prevProps.chartOptions !== this.props.chartOptions
    ) {
      this.setState({
        chartData: this.props.chartData || [],
        chartOptions: this.props.chartOptions || {},
      });
    }
  }

  render() {
    const {
      height = 260,
      width = "100%",           
      className = "",
    } = this.props;

    return (
      <div className={`w-full ${className}`}>
        <Chart
          options={this.state.chartOptions}
          series={this.state.chartData}
          type="bar"
          width={width}
          height={height}
        />
      </div>
    );
  }
}

export default BarChart;